import { notification } from "antd";
import { ZObjState } from "src/types/ZObjState";

/**
 * Состояния объекта с проверкой на дубли.
 *
 * Дубликат состояния ломает карты прав, которые строятся по его идентификатору,
 * поэтому пользователя предупреждают, но работу не останавливают — так было и в v1.
 */
export const checkStates = (states: ZObjState[]): ZObjState[] => {
  const seen = new Set<string>();
  const hasDuplicates = states.some(({ id }) => {
    const key = String(id);
    if (seen.has(key)) return true;
    seen.add(key);
    return false;
  });
  if (hasDuplicates) {
    notification.warning({
      message:
        "Список состояний содержит некорректные данные. Это может вызвать проблемы в работе приложения",
    });
  }
  return states;
};
